export function passwordMeetsMinRequirements(password) {
	let hasNumber = /\d/.test(password);
	let meetsMinLength = password.length >= 8;
	if (hasNumber && meetsMinLength) {
		return {
			passed: true,
		};
	} else {
		return {
			passed: false,
			error: "Must be a minimum of 8+ characters long and contain a number",
		};
	}
}
